import styles from './RichListItem.module.scss';

import clsx from 'clsx';
import { MouseEvent, type ReactNode } from 'react';

type BaseProps = {
  children: ReactNode;
};

type LinkProps = {
  href: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

type ClickableProps = {
  href?: undefined;
  onClick?: (event: MouseEvent<HTMLLIElement>) => void;
};

type Props = BaseProps & (LinkProps | ClickableProps);

export function RichListItem(props: Props) {
  const className = clsx(styles['root'], props.onClick && styles['clickable']);
  const onClick = props.href == null ? props.onClick : undefined;
  const content = <div className={styles['content']}>{props.children}</div>;
  const anchoredContent = props.href ? (
    <a className={styles['anchor']} href={props.href} onClick={props.onClick}>
      {content}
    </a>
  ) : undefined;

  return (
    <li className={className} onClick={onClick}>
      {anchoredContent || content}
    </li>
  );
}
